"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissionFormMock = void 0;
const uuid_1 = require("uuid");
const mission_document_model_1 = require("./mission-document.model");
const mission_document_type_enum_1 = require("../../enums/mission-document-type.enum");
const afto_781_v1_data_mock_1 = require("./afto_781_v1-data/afto_781_v1-data.mock");
class MissionFormMock extends mission_document_model_1.MissionDocument {
    constructor(data) {
        const seedData = {
            id: (0, uuid_1.v4)(),
            type: mission_document_type_enum_1.MissionDocumentType.AFTO_781_V1,
            data: new afto_781_v1_data_mock_1.AFTO781V1DataMock(),
        };
        super(seedData);
    }
}
exports.MissionFormMock = MissionFormMock;
